import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";

const GetRefundsByOrderId = (orderId) => {
    return useQuery(
        ["get-refunds-by-order-id", orderId],
        () =>
            request({
                url: `/payment/getAllRefundsForOrder/${orderId}`,
                method: "GET",
            }),
        {
            enabled: !!orderId,
            refetchOnWindowFocus: false,
        }
    );
};

export default GetRefundsByOrderId;